import { render, staticRenderFns } from "./professional.vue?vue&type=template&id=0a063849&scoped=true&"
import script from "./professional.vue?vue&type=script&lang=ts&"
export * from "./professional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a063849",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Cookies: require('/frontend/components/Cookies.vue').default})
